export { Badge } from '@mantine/core'